import { Injectable, NgZone } from '@angular/core';
import { BrazeService } from './braze.service';
import { AnalyticsService } from 'src/smoothr-web-app-core/services/analytics/analytics.service';
import { RepositoryService } from '../../smoothr-web-app-core/services/repository/repository.service';
import { Api } from 'src/smoothr-web-app-core/api/api';

declare var Cookiebot: any;

@Injectable({
	providedIn: 'root',
})
export class CookieConsentService {
	static marketing = false;
	private lastInitializedUid: string | null = null;

	constructor(
		private ngZone: NgZone,
		private brazeService: BrazeService,
		private analyticsService: AnalyticsService,
		private repoService: RepositoryService
	) {}

	public initializeCookieConsent() {
		this.ngZone.run(() => {
			window.addEventListener('CookiebotOnConsentReady', () => this.handleConsent());
		});
		// Cookiebot fires CookiebotOnConsentReady before Angular bootstrap completes on
		// subsequent page loads (stored consent). Read consent directly if already available.
		if (typeof (window as any).Cookiebot !== 'undefined' && (window as any).Cookiebot?.consent) {
			this.handleConsent();
		}
		this.repoService.customerAuth.subscribe(auth => {
			// Skip Braze initialization on the OAuth callback page — it redirects immediately
			// via window.location.replace(), so any session started here gets cancelled.
			// The home page will initialize Braze fresh via handleConsent() after the redirect.
			if (new URLSearchParams(window.location.search).has('id')) {
				return;
			}
			if (CookieConsentService.marketing && auth?.customer && !auth.customer.isAnonymous) {
				if (auth.customer.uid !== this.lastInitializedUid) {
					this.lastInitializedUid = auth.customer.uid;
					console.log('initializeBRAZE from customerAuth.subscribe in  initializeCookieConsent. userID:', auth.customer.uid);
					this.brazeService.initializeService(auth.customer.uid);
					this.brazeService.initUser(auth);
				}
			}
		});
	}

	private async handleConsent() {
		const cookiebot = (window as any).Cookiebot;
		const consent = cookiebot?.consent;
		if (consent) {
			Api.updateCookieConsent({
				statistics: !!consent.statistics,
				marketing: !!consent.marketing,
				preferences: !!consent.preferences,
				stamp: consent.stamp ?? '',
			}).catch(e => console.error('Failed to sync Cookiebot consent to backend', e));

			if (consent.marketing) {
				CookieConsentService.marketing = true;
				await this.setAnalyticsEnabled(true);
				// Initialize Braze only if a known (non-anonymous) user is already present.
				// For anonymous users, initialization is deferred until after order with email.
				const auth = this.repoService._customerAuth;
				if (auth?.customer && !auth.customer.isAnonymous && auth.customer.uid !== this.lastInitializedUid) {
					this.lastInitializedUid = auth.customer.uid;
					console.log('initializeBRAZE from handle CookieConsent. userID:', auth.customer.uid);
					this.brazeService.initializeService(auth.customer.uid);
					this.brazeService.initUser(auth);
				}
			} else {
				await this.setAnalyticsEnabled(false);
				this.brazeService.disableSdk();
			}
		}
	}

	async setAnalyticsEnabled(enabled: boolean) {
		await this.analyticsService.setAnalyticsCollectionEnabled(enabled);
	}
}
